/* WAVE Hair Extensions - early page fixes
   ------------------------------------------------------------------
   9 September 2026.

   This file runs in the <head>, before the theme's own scripts, and
   does three things. It is loaded from layout/theme.liquid.

   TO TURN THE WHOLE THING OFF: delete the one script line for this
   file in layout/theme.liquid. Nothing else depends on it.


   1. ROUNDS IMAGE WIDTHS
   ----------------------
   The theme shows colour swatches as background images. It measures
   the tile on screen, doubles it for retina screens, and asks
   Shopify for the image at that width. The measured tile is not a
   whole number of pixels, so it asks for a width of 69.9768.

   Shopify's image service only accepts WHOLE numbers. Given a
   fraction it ignores the instruction and serves the ORIGINAL file.

   Measured on Water Wave Nano Bonds, the Jet Black swatch:

     asked for 69.9768 wide  ->  2,709 KB, 1024 x 1536  (the original)
     asked for 70 wide       ->      8 KB,   70 x 105
     asked for 140 wide      ->     33 KB,  140 x 210  (retina)

   The tile is 35 pixels wide. It was pulling a two and a half
   megabyte photograph to fill it. Across 25 swatches that was about
   10 MB of an 18 MB product page.

   HOW THE THEME LOADS THEM, AND WHERE THIS STEPS IN. The page
   arrives with the swatch tiles empty. Theme JavaScript measures
   each tile and writes the address, fraction and all, into a
   data-bg attribute. The lazy loader later reads data-bg and sets
   the background, and that is when the download starts. This rounds
   the number while it still sits in data-bg.

   WHAT WAS TRIED FIRST. Watching the style attribute instead. It
   corrected every swatch and changed nothing: the page still pulled
   the same 10 MB, because by then the download had begun. Catching
   it one step earlier is the whole point.


   2. STOPS THE FONT AWESOME LIBRARY LOADING
   -----------------------------------------
   The homepage "PREMIUM LASTING QUALITY" band used three Font
   Awesome icons: an award, a palette and a water drop. To draw them
   it downloaded the ENTIRE Font Awesome library from an outside
   server: 425 KB and 84 ms of work, for three little pictures.

   The three icons are now drawn directly in assets/wave-cro.css as
   inline graphics, about 1 KB in total. This removes the library.

   BOTH HALVES ARE NEEDED. Delete the CSS and the icons vanish.
   Delete this and the 425 KB comes back.

   Verified: the browser starts the request and it is cancelled with
   ZERO bytes transferred and zero decoded, and the library never
   runs. The proper fix is to take that one script line out of the
   HTML block on the homepage, in Online Store > Themes > Customise.
   Doing it here avoided hand-editing a 30 KB template file and
   risking damage to unrelated homepage content.


   3. MARKS THE HERO IMAGE AS URGENT
   ---------------------------------
   Google's check on the homepage gives three verdicts on the main
   hero image: not lazy loaded PASS, findable in the HTML PASS,
   marked as high priority FAIL. That last one is what produces
   1,990 ms of "resource load delay", the browser finding the image
   and then queuing it behind everything else.

   TWO EARLIER ATTEMPTS PICKED THE WRONG IMAGE, so the test here is
   deliberately narrow:

     first try: "the first image that is not lazy loaded"
       -> matched the 115 x 43 header logo. Useless.
     second try: added a minimum width of 600
       -> matched a 3072 x 5504 image further down the page that
          carries no loading attribute at all. Still wrong.
     now: must say loading="eager" AND be at least 600 wide.

   That combination is exactly the hero. The theme marks whichever
   hero suits the device as eager: the 2240 x 1033 banner on a
   desktop, the 941 x 1672 one on a phone. Both logos are far below
   600 wide, so they are skipped.

   It is a hint to the browser, nothing more, and it changes nothing
   visually.


   SAFETY
   ------
   Everything here is wrapped in try/catch and falls back to doing
   nothing on any error. The width rounding only ever acts on a
   FRACTIONAL width, and its own edit turns that into a whole number,
   so the thing it looks for is destroyed by fixing it and it cannot
   loop. There is a hard cap of 800 edits per page load on top of
   that, and a cheap text check runs first so anything without an
   image width costs almost nothing.
   ------------------------------------------------------------------ */

(function () {
  'use strict';

  var TOKEN = 'wid' + 'th=';
  var FRACTION = /(width=)(\d+\.\d+)/g;
  var WATCHED = ['data-bg', 'data-bgset', 'data-src', 'data-srcset', 'style'];
  var MAX_EDITS = 800;
  var MIN_HERO_WIDTH = 600;
  var MAX_HERO_MARKS = 2;
  var edits = 0;
  var heroMarks = 0;

  /* ---------- 1. round fractional image widths ---------- */

  function toWhole(match, prefix, number) {
    var rounded = Math.round(parseFloat(number));
    if (!(rounded > 0)) rounded = 1;
    return prefix + rounded;
  }

  function round(value) {
    if (typeof value !== 'string' || value.indexOf(TOKEN) === -1) return value;
    FRACTION.lastIndex = 0;
    if (!FRACTION.test(value)) return value;
    FRACTION.lastIndex = 0;
    return value.replace(FRACTION, toWhole);
  }

  function fixAttr(el, name) {
    if (edits >= MAX_EDITS) return;
    if (!el || el.nodeType !== 1 || !el.getAttribute) return;
    var value = el.getAttribute(name);
    if (!value) return;
    var fixed = round(value);
    if (fixed === value) return;
    el.setAttribute(name, fixed);
    edits++;
  }

  function fixEl(el) {
    for (var i = 0; i < WATCHED.length; i++) fixAttr(el, WATCHED[i]);
  }

  /* ---------- 2. stop the Font Awesome library ---------- */

  function blockFontAwesome(el) {
    if (!el || el.nodeType !== 1 || el.tagName !== 'SCRIPT') return;
    var src = el.getAttribute('src');
    if (!src || src.indexOf('fontawesome') === -1) return;
    el.type = 'text/wave-blocked';
    el.removeAttribute('src');
    if (el.parentNode) el.parentNode.removeChild(el);
  }

  /* ---------- 3. mark the hero image as urgent ---------- */

  function markHero(el) {
    if (heroMarks >= MAX_HERO_MARKS) return;
    if (!el || el.nodeType !== 1 || el.tagName !== 'IMG') return;
    if (el.getAttribute('loading') !== 'eager') return;
    var declared = parseInt(el.getAttribute('width') || '0', 10);
    if (!(declared >= MIN_HERO_WIDTH)) return;
    if (el.getAttribute('fetchpriority')) { heroMarks++; return; }
    el.setAttribute('fetchpriority', 'high');
    heroMarks++;
  }

  /* ---------- shared walking ---------- */

  function handle(el) {
    fixEl(el);
    blockFontAwesome(el);
    markHero(el);
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    handle(root);
    if (!root.querySelectorAll) return;
    var found = root.querySelectorAll('img, script[src], [data-bg], [data-bgset], [data-src], [data-srcset], [style]');
    for (var i = 0; i < found.length; i++) handle(found[i]);
  }

  try {
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'attributes') {
          fixAttr(r.target, r.attributeName);
        } else if (r.addedNodes) {
          for (var j = 0; j < r.addedNodes.length; j++) scan(r.addedNodes[j]);
        }
      }
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: WATCHED,
      subtree: true,
      childList: true
    });
  } catch (e) {}

  /* Belt and braces: catch anything written through setAttribute. */
  try {
    var nativeSetAttribute = Element.prototype.setAttribute;
    Element.prototype.setAttribute = function (name, value) {
      try {
        if (name && WATCHED.indexOf(name) !== -1) value = round(value);
      } catch (e) {}
      return nativeSetAttribute.call(this, name, value);
    };
  } catch (e) {}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document.documentElement); });
  } else {
    scan(document.documentElement);
  }
})();
